import { z } from 'my-zod'
import { vehicleDispositionPreCheckAnswers } from './vehicle-dispositions-v2-model'

export const vehicleDispositionPreCheckModel = z.object({
  vehicleId: z.number(),
  notes: z.string().nullable(),
  answers: vehicleDispositionPreCheckAnswers
})

export type vehicleDispositionPreCheckModel = z.infer<typeof vehicleDispositionPreCheckModel>
